
import service from '@/components/service.vue'//客服
import shopFloat from '@/components/shopFloat.vue';//购物车悬浮窗
import Top from "@/components/top.vue";//回到顶部组件
import foot from "@/components/foot.vue";//回到顶部组件
import authorizationDetail from '@/components/authorizationDetail.vue'//版权说明

//数组存放接收的组件名
const components = [ shopFloat,service,Top,authorizationDetail,foot]
 
const install = function(Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
 };

export default {
    install
};



//////////////////
// WEBPACK FOOTER
// ./src/utils/bathComponents.js
// module id = null
// module chunks = 